import React from 'react';
import { motion } from 'framer-motion';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <motion.footer 
      className="bg-black/90 border-t border-gold-900/30"
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 1, delay: 0.5 }}
    >
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <motion.div 
            className="col-span-1 md:col-span-2"
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
          >
            <h3 className="text-gold-400 text-lg font-semibold mb-4">SETORA</h3>
            <p className="text-gray-400 text-sm mb-4 max-w-md">
              Custom software and AI for small businesses — the web apps, mobile apps, and tools growing companies run on.
            </p>
            <div className="flex space-x-4">
              <motion.a 
                href="https://twitter.com/setora_ai" 
                className="text-gold-500 hover:text-gold-300 transition-colors duration-300"
                whileHover={{ scale: 1.2 }}
                whileTap={{ scale: 0.8 }}
              >
                <span className="sr-only">Twitter</span>
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84"></path>
                </svg>
              </motion.a>
              <motion.a 
                href="https://linkedin.com/company/setora-ai" 
                className="text-gold-500 hover:text-gold-300 transition-colors duration-300"
                whileHover={{ scale: 1.2 }}
                whileTap={{ scale: 0.8 }}
              >
                <span className="sr-only">LinkedIn</span>
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path fillRule="evenodd" d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" clipRule="evenodd"></path>
                </svg>
              </motion.a>
            </div>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.7 }}
          >
            <h4 className="text-gold-400 font-medium mb-3">Company</h4>
            <ul className="space-y-2 text-sm">
              <li><a href="/about" className="text-gray-400 hover:text-gold-300 transition-colors">About Us</a></li>
              <li><a href="/#services" className="text-gray-400 hover:text-gold-300 transition-colors">Services</a></li>
              <li><a href="/#work" className="text-gray-400 hover:text-gold-300 transition-colors">Our Work</a></li>
            </ul>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.8 }}
          >
            <h4 className="text-gold-400 font-medium mb-3">Support</h4>
            <ul className="space-y-2 text-sm">
              <li><a href="/contact" className="text-gray-400 hover:text-gold-300 transition-colors">Contact Us</a></li>
              <li><a href="#help" className="text-gray-400 hover:text-gold-300 transition-colors">Help Center</a></li>
              <li><a href="#faq" className="text-gray-400 hover:text-gold-300 transition-colors">FAQ</a></li>
            </ul>
          </motion.div>
        </div>
        <motion.div 
          className="mt-12 pt-6 border-t border-gold-900/20 flex flex-col md:flex-row justify-between items-center"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 0.9 }}
        >
          <p className="text-gray-500 text-sm">
            &copy; {currentYear} Setora. All rights reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <a href="https://setora.ai" className="text-gold-400 hover:text-gold-300 transition-colors duration-300">Setora Home</a>
            <button className="text-gold-400 hover:text-gold-300 transition-colors duration-300 styled-as-link">Coming Soon</button>
          </div>
        </motion.div>
      </div>
    </motion.footer>
  );
};

export default Footer; 